module.exports = __webpack_public_path__ + "static/media/stock-tweeter.bce2c8e5.png";